// extracted by mini-css-extract-plugin
export default {"form":"ExpenseForm_form__YGn2K","input":"ExpenseForm_input__5PBHb","submitBtn":"ExpenseForm_submitBtn__n1GJn"};